import { useQuery } from "@apollo/client";
import Errors from "components/Errors";
import Page from "components/Page";
import Spinner from "components/Spinner";
import useAutoScrollToBottom from "hooks/useAutoScrollToBottom";
import { useParams } from "react-router-dom";
import { FETCH_PRODUCT_STOCK_DETAIL } from "./graphql";
import InventoryProductTableView from "./InventoryProductTableView";

const InventoryProductPage = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(FETCH_PRODUCT_STOCK_DETAIL, {
    variables: { id },
  });
  const ref = useAutoScrollToBottom(data);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const supplierStock = JSON.parse(data.supplierStock);

  console.log("supplierStock", supplierStock);

  return (
    <Page
      title={data.product.nameCn}
      subtitle={`[${data.product.number}] ${data.product.name}`}
      backTo="./.."
    >
      <div className="flex-1 whitespace-nowrap overflow-auto text-sm" ref={ref}>
        <InventoryProductTableView
          product={data.product}
          rows={supplierStock}
        />
      </div>
    </Page>
  );
};

export default InventoryProductPage;
